import {
  Hand,
  LinkIcon,
  Mail,
  MessageSquareMore,
  QrCode,
  Send,
  SquareDashedBottomCode,
  Store,
  WebhookIcon,
} from "lucide-react"
import { BigBlueIcon } from "modules/shared/icons/bigblue"
import { WhatsappIcon } from "modules/shared/icons/whatsapp"
import { useBigBlueIntegrationQuery } from "modules/settings/hooks/bigblue/useBigBlueIntegrationQuery"
import { useMemo } from "react"
import { useTranslation } from "react-i18next"
import { CampaignTriggerTypeEnum, areBigBlueWebhooksWorking } from "schema"

export function useTriggerKind() {
  const { t } = useTranslation()
  const { data: bigBlueIntegration } = useBigBlueIntegrationQuery()
  const areBigBlueWebhooksReady = areBigBlueWebhooksWorking(bigBlueIntegration)

  const items = useMemo(
    () => ({
      [CampaignTriggerTypeEnum.Shopify]: {
        icon: Store,
        value: CampaignTriggerTypeEnum.Shopify,
        label: t("campaigns.trigger.kind.options.shopify.label"),
        description: t("campaigns.trigger.kind.options.shopify.description"),
        active: true,
        enabled: true,
        beta: false,
      },
      [CampaignTriggerTypeEnum.BigBlue]: {
        icon: BigBlueIcon,
        value: CampaignTriggerTypeEnum.BigBlue,
        label: t("campaigns.trigger.kind.options.bigblue.label"),
        description: areBigBlueWebhooksReady
          ? t("campaigns.trigger.kind.options.bigblue.description")
          : t("campaigns.trigger.kind.options.bigblue.disabledDescription"),
        active: true,
        enabled: areBigBlueWebhooksReady,
        beta: false,
      },
      [CampaignTriggerTypeEnum.Manual]: {
        icon: Hand,
        value: CampaignTriggerTypeEnum.Manual,
        label: t("campaigns.trigger.kind.options.manual.label"),
        description: t("campaigns.trigger.kind.options.manual.description"),
        active: true,
        enabled: true,
        beta: false,
      },
      [CampaignTriggerTypeEnum.Webhook]: {
        icon: WebhookIcon,
        value: CampaignTriggerTypeEnum.Webhook,
        label: t("campaigns.trigger.kind.options.webhook.label"),
        description: t("campaigns.trigger.kind.options.webhook.description"),
        active: true,
        enabled: true,
        beta: false,
      },
      [CampaignTriggerTypeEnum.Widget]: {
        icon: SquareDashedBottomCode,
        value: CampaignTriggerTypeEnum.Widget,
        label: t("campaigns.trigger.kind.options.widget.label"),
        description: t("campaigns.trigger.kind.options.widget.description"),
        active: true,
        enabled: true,
        beta: false,
      },
      [CampaignTriggerTypeEnum.InstagramDirectMessage]: {
        icon: Send,
        value: CampaignTriggerTypeEnum.InstagramDirectMessage,
        label: t("campaigns.trigger.kind.options.instagramDirectMessage.label"),
        description: t("campaigns.trigger.kind.options.instagramDirectMessage.description"),
        active: true,
        enabled: true,
        beta: false,
      },
      [CampaignTriggerTypeEnum.InstagramCommentReply]: {
        icon: MessageSquareMore,
        value: CampaignTriggerTypeEnum.InstagramCommentReply,
        label: t("campaigns.trigger.kind.options.instagramCommentReply.label"),
        description: t("campaigns.trigger.kind.options.instagramCommentReply.description"),
        active: true,
        enabled: true,
        beta: false,
      },
      [CampaignTriggerTypeEnum.EmailInbox]: {
        icon: Mail,
        value: CampaignTriggerTypeEnum.EmailInbox,
        label: t("campaigns.trigger.kind.options.emailInbox.label"),
        description: t("campaigns.trigger.kind.options.emailInbox.description"),
        active: true,
        enabled: true,
        beta: false,
      },
      [CampaignTriggerTypeEnum.Link]: {
        icon: LinkIcon,
        value: CampaignTriggerTypeEnum.Link,
        label: t("campaigns.trigger.kind.options.link.label"),
        description: t("campaigns.trigger.kind.options.link.description"),
        active: true,
        enabled: true,
        beta: false,
      },
      [CampaignTriggerTypeEnum.QR]: {
        icon: QrCode,
        value: CampaignTriggerTypeEnum.QR,
        label: t("campaigns.trigger.kind.options.qr.label"),
        description: t("campaigns.trigger.kind.options.qr.description"),
        active: true,
        enabled: true,
        beta: false,
      },
      [CampaignTriggerTypeEnum.WhatsappDefault]: {
        icon: WhatsappIcon,
        value: CampaignTriggerTypeEnum.WhatsappDefault,
        label: t("campaigns.trigger.kind.options.whatsappDefault.label"),
        description: t("campaigns.trigger.kind.options.whatsappDefault.description"),
        active: false,
        enabled: false,
        beta: false,
      },
    }),
    [areBigBlueWebhooksReady, t],
  )

  return { items }
}
